import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77249daf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "苗豆不足啦！", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "当前您的苗豆余额不足", -1))
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("我要充值")
const _hoisted_6 = { class: "toVip" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("成为会员")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createBlock(_component_VanPopup, {
    show: _ctx.isShow,
    "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShow) = $event)),
    style: {"border-radius":"4px"},
    closeable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_VanImage, {
          src: require("@/assets/img/miaodoubuzu.png"),
          width: "4rem",
          height: "4rem"
        }, null, 8, ["src"]),
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_VanButton, {
            round: "",
            style: {"width":"200px"},
            color: "#FFCC32",
            onClick: _ctx.jumpToWeCaht
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.jumpToWeCahtVip && _ctx.jumpToWeCahtVip(...args)))
          }, "免扣苗豆 >>")
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}